import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../firebase/firebaseConfig";
import fallbackVi from "./locales/vi/translation.json";
import fallbackEn from "./locales/en/translation.json";

const cachePrefix = "i18n_cache_";

function getCache(lang) {
  const raw = localStorage.getItem(cachePrefix + lang);
  if (!raw) return null;
  try {
    const { data, version } = JSON.parse(raw);
    return { data, version };
  } catch {
    return null;
  }
}

function setCache(lang, data, version) {
  localStorage.setItem(
    cachePrefix + lang,
    JSON.stringify({ data, version })
  );
}

// Khởi tạo i18n (rỗng resource)
i18n.use(initReactI18next).init({
  lng: "vi",
  fallbackLng: "vi",
  interpolation: { escapeValue: false },
  resources: {},
});

// Hàm fetch + nạp resource có kiểm tra version
export async function loadI18nResource(lang = "vi") {
  // 1. Lấy cache (nếu có)
  const cached = getCache(lang);

  // 2. Fetch Firestore
  try {
    const snap = await getDoc(doc(db, "i18n", lang));
    if (snap.exists()) {
      const firestoreData = snap.data();
      const version = firestoreData.version || 1;
      // Nếu cache cùng version, dùng luôn cache
      if (cached && cached.version === version) {
        i18n.addResourceBundle(lang, "translation", cached.data, true, true);
        return;
      }
      // Nếu version mới, nạp bản dịch Firestore & cache lại
      i18n.addResourceBundle(lang, "translation", firestoreData, true, true);
      setCache(lang, firestoreData, version);
      return;
    }
  } catch {
    // Ignore, fallback bên dưới
  }

  // 3. Fallback về file tĩnh nếu fetch lỗi
  let fallback = lang === "vi" ? fallbackVi : fallbackEn;
  i18n.addResourceBundle(lang, "translation", fallback, true, true);
}

export default i18n;
